<template>
  <div class="input-boxplot">
    <div style="margin-bottom: 10px; padding: 10px; background: #ebebeb">
        Render boxplots of different omics data by select or input the list of interested genes. <br><br>
        * The p-values of lines are calculated based on student t-test.
      </div>
      
    <!-- <v-autocomplete
        v-model="boxplotGenes"
        :items="genes"
        outlined
        chips
        deletable-chips
        small-chips
        :menu-props="{closeOnContentClick: true}"
        dense
        :label="`Select up to ${maxGenes} genes`"
        multiple
        clearable
    >
    </v-autocomplete>
    <div
      @click="submitBoxplotGenes"
    >
    <v-btn
        v-if="boxplotGenes.length > 0"
        :loading="loaderBoxplot"
        :disabled="loading || !valid"
        color="blue-grey"
        class="ma-2 white--text"
      >
        
        {{ valid ? 'Render boxplots' : 'Select fewer genes' }}
    </v-btn>
    </div>
    
    <input-boxplot-customize /> -->
    <!-- <div class="ttest-descriptor">
      Note: p-values calculated with <a href="https://www.npmjs.com/package/ttest">npm ttest package</a>
    </div> -->

    <!-- test for tabs by select & input list -->

    <!-- <div>
    <input type="checkbox" id="discovery" value="discovery" v-model="cohortSelected" />
    <label>&nbsp;Discovery Cohort</label>
    <br>
    <input type="checkbox" id="validation" value="validation" v-model="cohortSelected" />
    <label>&nbsp;Validation Cohort</label>
    
  </div> -->
<!-- <p>Checked: {{ cohortSelected }}</p> -->
    <v-app class="input-boxplot-tabs">
      <v-card flat>
      <v-tabs
        v-model="tab"
      >
          <v-tab href="#tab-1">
            Select<br>gene(s)
          </v-tab>
          <v-tab href="#tab-2">
            Select<br>cell type(s)
          </v-tab>
          <v-tab href="#tab-3">
            Enter<br>list
          </v-tab>

          <!-- <v-tab href="#tab-3">
            Download
          </v-tab> -->
        </v-tabs>

        <v-tabs-items v-model="tab">

          <v-card style="margin-top: 20px;">

            <v-tab-item value="tab-1">
            <div>
              <v-autocomplete
              class="larger-input"
        v-model="boxplotGenes"
        :items="genes"
        outlined
        chips
        deletable-chips
        small-chips
        :menu-props="{closeOnContentClick: true}"
        :label="`Select up to ${maxGenes} genes`"
        multiple
        clearable
    >
    </v-autocomplete>


    <!-- <v-btn
        v-if="boxplotGenes.length > 0"
        :loading="loaderBoxplot"
        :disabled="loading || !valid"
        color="blue-grey"
        class="ma-2 white--text"
      >
        
        {{ valid ? 'Render boxplots' : 'Select fewer genes/air toxics' }}
    </v-btn> -->
    
  </div>
            </v-tab-item>
                        <v-tab-item value="tab-2">
            <div>
              <v-autocomplete
              class="larger-input"
        v-model="boxplotCellTypes"
        :items="celltype"
        outlined
        chips
        deletable-chips
        small-chips
        :menu-props="{closeOnContentClick: true}"
        :label="`Select up to cell types`"
        multiple
        clearable
    >
    </v-autocomplete>
  </div>
            </v-tab-item>

            <v-tab-item value="tab-3">
              <v-textarea
              class="larger-input"
        v-model="inputGenesText"
        outlined
        name="input-7-4"
        label="Enter list of genes separated by newline"
        height="120"
        no-resize
      ></v-textarea>
      <div
      @click="submitBoxplotGenes"
    >
      
    </div>
    <!-- <input-boxplot-customize /> -->
            </v-tab-item>

            <!-- <v-tab-item value="tab-3">
              3
            </v-tab-item> -->

          </v-card>
          <v-autocomplete
            :items="stratifyByOptions"
            label="Clinical feature to stratify by:"
            v-model="stratifyBy"
          ></v-autocomplete>

        </v-tabs-items>
          <div @click="submitBoxplotGenes">
            <v-btn
            v-if="boxplotGenes.length > 0 || boxplotCellTypes.length > 0"
            :loading="loaderBoxplot"
            :disabled="loading || !valid"
            color="blue-grey"
            class="ma-2 white--text"
          >
            {{ valid ? 'Render boxplots' : 'Select fewer genes' }}
    </v-btn>
    </div>
      </v-card>

      <input-boxplot-customize :studySelected="this.studySelected" />
    <div v-if="twoCohorts()">
      <input type="checkbox" id="discovery" value="discovery" v-model="cohortSelected" />
      <label>&nbsp;Discovery cohort</label>
      <br>
      <input type="checkbox" id="validation" value="validation" v-model="cohortSelected" />
      <label>&nbsp;Validation cohort</label>
    </div>
       <!-- <p>Checked: {{ cohortSelected }}</p> -->
    </v-app> 
    
    
  </div>
</template>

<script>
// import available from '../../refs/available'
import available from '../../refs/available';
import cellTypes from '../../refs/cellTypes';
import InputBoxplotCustomize from './InputBoxplotCustomize.vue'
import stratifyVar from '../../refs/stratifyVar'

export default {
    components: { InputBoxplotCustomize },
    name: "input-boxplot",
    props: ['studySelected'],
    computed: {
        available() {
          console.log('computed available boxplot', this.studySelected)

          if (this.studySelected === 'PCC') {
            return this.$store.state.availableGenes['PCC']
          } else {
            return this.$store.state.availableGenes['PTRC']
          }
          // return this.$store.state.available 
        },
      categoryTracks() { 
        console.log('inputboxplotcustomize categoryTracks study selected', this.studySelected)
        return this.$store.state.Boxplot_categoryTracks[this.studySelected] 
      },
      stratifyByOptions() {        
        console.log('inputboxplotcustomize stratifyByOptions', this.categoryTracks)
        // return Object.values(this.categoryTracks).flat().filter(track => (!this.categoryTracks.Numerical.includes(track) && track !== 'response'))
        return [stratifyVar[this.studySelected]['VarName'], ...Object.values(this.categoryTracks)]

      },
      
        loaderBoxplot() { return this.$store.state.loaderBoxplot },
        genes() { 
            // console.log('computed genes boxplot', this.studySelected, this.available)

            const available = Object.keys(this.available)
            available.sort()
            return available
        },
        celltype() {

            // const available = Object.keys(this.available)

            // available.sort()
            var celltype_ = cellTypes[this.studySelected]
            // celltype_.sort()

            return celltype_
        },
        inputGenesText: {
          get() { 
            return this.boxplotGenes.join('\n') 
          },
          set(inputGenesText) { 
            this.boxplotGenes = inputGenesText
                  .split('\n')
                  .filter(gene => ((gene.length > 0) || (this.genes.includes(gene))))
                  // .map(gene => gene.toUpperCase())
          }, 
        },
        tab: {
          get() { return this.$store.state.Boxplot_tab },
          set(tab) { this.$store.dispatch('setViewAttr', { view: 'Boxplot', attrKey: 'tab', attrVal: tab }) },
        },
        cohortSelected: {
          get() { return this.$store.state.Boxplot_cohortSelected },
          set(v) { 
            // console.log
            this.$store.dispatch(
              'setViewAttr', { 
                view: 'Boxplot',
                attrKey: 'cohortSelected',
                attrVal: v 
              }
            )}
        },
        stratifyBy: {
          get() { 
            var stratifyBy_ = this.$store.state.Boxplot_stratifyByPrimary
            if (stratifyBy_ === null) {
              stratifyBy_ = stratifyVar[this.studySelected]['VarName']
            } 
            return stratifyBy_
            
              // return this.$store.state.Boxplot_stratifyByPrimary 
          },
          set(v) { 
            console.log('boxplot vue set stratifyby', v)
            this.$store.dispatch(
              'setViewAttr', { 
                view: 'Boxplot',
                attrKey: 'stratifyByPrimary',
                attrVal: v 
              }
            )}
        },
        valid() { 
          var gene_valid = this.boxplotGenes.length <= this.maxGenes && this.boxplotGenes.length > 0
          var celltypes_valid = this.boxplotCellTypes.length <= this.maxGenes && this.boxplotCellTypes.length > 0
          return  gene_valid || celltypes_valid
        },
    },
    
    data: () => ({
        // boxplotGenes: ['CA9', 'ANGPTL4', 'VEGFA', 'EGLN3', 'PLVAP', 'ENPP3', 'SLC6A3'],
        boxplotGenes: ['A1BG', 'A2ML1', 'ACD', 'DUS2'],
        boxplotCellTypes: [],
        // stratifyBy: stratifyVar[this.studySelected]['VarName'],
        loading: false,
        maxGenes: 10,
        availableGenes: [],
        available
        // cohortSelected: ['discovery', 'validation'],
    }),


    methods: {
        submitBoxplotGenes() {
            console.log('submitBoxplotGenes', this.boxplotCellTypes)
            this.$store.dispatch('getTracks', 
            { 
              view: 'Boxplot', 
              genes: [...this.boxplotGenes, ...this.boxplotCellTypes], 
              studySelected: this.studySelected,
              stratifyVar: this.stratifyBy
            }
          )
          // this.$store.dispatch(
          //   'setViewAttr', { 
          //     view: 'Boxplot',
          //     attrKey: 'cohortSelected',
          //     attrVal: this.cohortSelected 
          //   }
          // )
        },
        twoCohorts() {
            return this.studySelected === 'PTRC'
        },
    },
    watch: {
      studySelected() {
        this.$store.dispatch(
              'setViewAttr', { 
                view: 'Boxplot',
                attrKey: 'stratifyByPrimary',
                attrVal: stratifyVar[this.studySelected]['VarName']
              })
        
        this.submitBoxplotGenes()
      },
      stratifyBy() {
        this.submitBoxplotGenes()
      },

      available() {
        // genes() { 
        console.log('watch available boxplot', this.available, this.studySelected)
            const available = Object.keys(this.available)
            available.sort()
            this.genes = available
        // },
      }
    },

    mounted() { this.submitBoxplotGenes() }
}
</script>

<style>
.input-boxplot {
    margin: 5px;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}



.ttest-descriptor {
  width: 100%;
  margin: 10px;
  font-size: 0.8em;
}

.input-boxplot-tabs{
  margin: 10px;
  height: 210px;
  display: flex;
  flex-wrap: nowrap;
}
</style>